/* eslint-disable no-console */
import { SentryService } from "@shared/services/sentry-service/sentry-service";
import { isError } from "lodash-es";

const SERVER_ERROR = "Server isn't responding. please try again later.";
const DEFAULT_ERROR = "Unknown error.";
const LIMIT_ERROR = 4; // 30 sec

/** initialState */
export const initialErrorState = {
  number: 0,
  message: null,
  hasLimit: false,
};

/**
 * @param {Object} state with object `error`
 * @param {string} message with `payload`
 * @param limit
 * @return {error} error
 * @property {number} number
 * @property {(string, null)} message
 * @property {boolean} hasLimit
 * @description Set error state.
 */
export function setError(
  { number: oldNumber = 0 },
  message = DEFAULT_ERROR,
  limit = LIMIT_ERROR
) {
  const number = oldNumber + 1;

  return {
    number,
    message,
    hasLimit: number >= limit,
  };
}

/**
 * @param {(string, null)} message
 * @description Display error in console.
 */
export function showServerError(message = SERVER_ERROR) {
  console.error(message);
}

export function serverErrorHandler(response) {
  let stringError = DEFAULT_ERROR;

  if (isError(response)) {
    stringError = response.message;
  }

  if (typeof response === "string") {
    stringError = response;
  }

  SentryService.sendMessage(stringError);

  return stringError;
}
